<template>
    <LoadingAnimation animation-style="bars" v-if="isStatusLoading"></LoadingAnimation>
    <div v-else class="w-100 user-modal-register-plan-select-view px-2">
      <div v-if="isLegacy() === true" style="max-width: 607px;">
        <div class="alert alert-warning gap-10 d-flex flex-column align-items-center p-5">
            <p class="font-size-sm-200">{{ translate("You're still on a legacy subscription plan") }}</p>
            <p class="font-size-sm-125">{{ translate("Your legacy subscription does not allow to buy \"Pay As You Go\" Credits.") }}</p>
            <p class="font-size-sm-125">{{ translate("Please contact our support team to cancel your legacy subscription now and get a partial refund.") }}</p>
            <p class="font-size-sm-125">{{ translate("You can then choose one of our new subscription plans and get additional \"Pay As You Go\" Credits as needed.") }}</p>
            <button class="btn btn-lg contact-btn" @click="openContactSupport">
                <span>{{ translate("Contact support") }}</span>
            </button>
        </div>
      </div>
      <div v-if="isLegacy() === false">
        <div class="mb-4 text-center">
            <p class="font-weight-bold font-size-200 mb-0">
                {{ translate('Choose Your Plan') }}
            </p>
        </div>

        <div class="position-relative w-100" v-for="plan in plans">
            <div v-if="plan.isMostPopular" class="most-popular-badge font-weight-bold">
                <span class="text-white align-self-center mr-3"> {{ translate('Most Popular') }}</span>
            </div>
            <SelectBillingItem
                :disabled="isSubmitting"
                :enable-learn-more="true"
                :learn-more-texts="plan.learnMoreTexts"
                :plan-billing-item="true"
                :plan-billing-item-use="plan.planBillingItemUse"
                :plan-billing-item-credit="plan.planBillingItemCredit"
                :price-string-monthly="plan.priceStringMonthly"
                :item-value="plan.itemValue"
                :name="plan.name"
                @closeLearnmore="toggleLearnMore"
                v-model="selectedProduct"
                :default-styles="plan.styles"
                class="mb-2 border"
                :class="{
                    'radio-panel-selected-modal': selectedProduct === plan.itemValue,
                    'bg-white': selectedProduct != plan.itemValue,
                    'most-popular-br-8': plan.isMostPopular,
                    'br-8': !plan.isMostPopular,
                }"
            >
                <!-- <div v-if="plan.isMostPopular" class="most-popular-badge font-weight-bold">
                    <span class="text-white align-self-center mr-3"> {{ translate('Most Popular') }}</span>
                </div> -->
                <span class="d-inline-flex flex-row flex-wrap-reverse h-100">
                    <span class="d-inline-flex flex-column justify-content-between mr-1">
                        <span
                            class="font-weight-bold font-size-125 mb-1 ml-n2 mt-n1 d-inline-flex flex-wrap title-text"
                        >
                            <span class="ml-2_">{{ translate(plan.transKey) }}</span>
                            <span v-if="plan.isMostPopular" class="most-popular-badge-mobile">
                                {{ translate('Most Popular') }}
                            </span>
                        </span>
                        <template v-for="info in plan.infoTexts">
                            <span>
                                <i v-if="info.icon" class="fa fa-check"></i>
                                <i v-else>
                                    <CoinSVG />
                                </i>
                                <span class="pl-1" v-html="info.text"></span>
                            </span>
                        </template>
                        <a
                            class="learn-more-link text-underline cursor-pointer font-size-100 user-select-none white-space-nowrap position-relative"
                            @click.stop.prevent="toggleLearnMore(plan.name)"
                        >
                            <span
                                class="learn-more-link position-absolute top-0 left-0"
                                :class="{ 'opacity-0': !plan.showLearnMore }"
                                >{{ translate('show less') }}</span
                            >
                            <span :class="{ 'opacity-0': plan.showLearnMore }">{{ translate('learn more') }}</span>
                        </a>
                    </span>
                </span>
            </SelectBillingItem>
        </div>

        <ButtonWithLoadingState
            data-user-modal-button-submit
            class="btn btn-success btn-lg btn-block font-weight-bold text-uppercase rounded my-4"
            icon="fa fa-arrow-right lh-1"
            :text="translate('Continue')"
            :is-state-loading="isSubmitting"
            :show-icon-after-text="true"
            @click.stop.prevent="goToChooseBilling"
        ></ButtonWithLoadingState>

        <div class="mb-3 text-center d-flex flex-column">
            <span class="mr-2_ mb-2" v-if="this.selectedProduct === 'payg'"><i class="far fa-check mr-1_"></i>{{ translate('Credits valid for one year') }}</span>
            <span class="mr-2_ mb-2" v-if="this.selectedProduct === 'subscription'"><i class="far fa-check mr-1_"></i>{{ translate('Cancel anytime') }}</span>
            <span
                ><i class="far fa-check mr-1_"></i
                >{{ translate('Two week money back guarantee, no questions asked') }}</span
            >
        </div>
    </div>
    </div>
</template>

<script>
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { userModalRoute } from '../router';
import SelectBillingItem from '../components/SelectBillingItem';
import ButtonWithLoadingState from '../../../../../qaamgo/modules/sat/components/form/ButtonWithLoadingState';
import { translate } from '../../../../../qaamgo/helper/translate';
import { paymentManager } from '../../../../payment/payment-manager';
import { pageStoreMixin } from '../../../../store/page-store';
import { testIsNonEmptyString } from '../../../../../lib/test-and-assert/test-base';
import { globalLogger } from '../../../../../qaamgo/helper/global-logger';
import { satGlobals } from '../../../../../qaamgo/sat/helper/sat-globals';
import DataStatus from '../../../../../qaamgo/modules/sat/components/mixins/DataStatus';
import CoinSVG from '../../../../../qaamgo/modules/sat/components/form/icons/CoinSVG.vue';
import { paymentApi } from '../../../../payment/payment-api';
import { pageNotification } from '../../../../../../js/qaamgo/helper/notify';
import LoadingAnimation from '../../../../../qaamgo/modules/sat/components/LoadingAnimation.vue';
import { eventBus } from '../../../../../lib/event-bus/event-bus';
import {projectHelper} from "../../../../misc/project-helper";

const TOGGLE_LEARN_MORE = 'toogle-learn-more';
export default {
    name: 'RegisterPlanSelectCreditsView',
    components: { LoadingAnimation, SelectBillingItem, ButtonWithLoadingState, CoinSVG },
    mixins: [TransFilter, DataStatus, pageStoreMixin],
    created() {
        if (paymentManager.isPricingInfoInitialized()) {
            this.initPlans();
            this.setStatusDone();
            this.store.userPaymentModal.setSubmitting(false);

            return;
        }

        paymentApi
            .getPricingInformation(true)
            .then((pricingInformation) => {
                paymentManager.setConfigFromPricingInformation(pricingInformation);
                this.initPlans();
                this.store.userPaymentModal.setSubmitting(false);
                this.setStatusDone();
            })
            .catch((error) => {
                pageNotification.showGenericErrorMessage();

                globalLogger.log('user modal - plan select - getPricingInformation - fail', error);
            });
    },
    beforeMount() {
        if (!testIsNonEmptyString(this.selectedProductStore)) {
            this.store.userPaymentModal.setSelectedProduct('pro');
        }
    },
    watch: {
        selectedProduct(plan) {
            this.store.userPaymentModal.setSelectedProduct(plan);
        },
        selectedProductStore(plan) {
            if (this.selectedProduct !== plan) {
                this.selectedProduct = plan;
            }
        },
    },
    computed: {
        /** @return {Boolean} */
        isSubmitting() {
            return this.store.userPaymentModal.isSubmitting;
        },
        learnMoreTexts() {
            let texts = [
                translate('Two week <strong>money back guarantee</strong>, no questions asked'),
                translate('Free customer support'),
                translate('Join millions of other happy Img2Go users.'),
            ];

            return texts;
        },
        selectedProductStore() {
            return this.store.userPaymentModal.selectedProduct;
        },
        currency() {
            return this.store.userPaymentModal.currency;
        },
    },
    methods: {
      getPricingLink() {
        return satGlobals.getPricingUrl();
      },
      isLegacy() {
        let user =  this.store.user.getUser;
        if (projectHelper.isImg2go() === true && user.isLegacySubscription() === true) {
          return true;
        }

        return false;
      },
        getMonthlyPrice(product) {
            return paymentManager.getSlugHelper().getMonthlyPriceForAnnual(
                {
                    billing: 'annual',
                    product,
                    plan: 'individual',
                },
                this.currency
            );
        },
        goToChooseBilling() {
            // user modal - product select - starter
            // user modal - product select - pro
            // user modal - product select - ultimate
            globalLogger.log('user modal - product select - ' + this.selectedProduct);

            if (satGlobals.isMultipleProductsEnabled()) {
                this.store.userPaymentModal.setCanGoBack(true);
            }

            this.$router.push({
                name: userModalRoute.REGISTER_CHOOSE_BILLING,
            });
        },
        initPlans() {
            this.plans = [
                {
                    learnMoreTexts: [
                        translate('Enjoy unlimited access to basic tools such as Photo Editor, Compress, and more.'),
                        translate(
                            'Gain <strong>400 Credits</strong> to utilize premium tools like AI Upscale, Colorize image, and others.'
                        ),
                        translate('Unlock additional features, including a wider range of styles and more AI models.'),
                        ...this.learnMoreTexts,
                    ],
                    planBillingItemUse: translate('Regular use'),
                    priceStringMonthly: this.getMonthlyPrice('pro'),
                    planBillingItemCredit: '400',
                    itemValue: 'pro',
                    name: 'pro',
                    transKey: 'Pro',
                    infoTexts: [
                        {
                            text: translate(
                                '<strong>400 Credits</strong> for <span class="text-primary font-weight-bold">premium tasks</span>'
                            ),
                            icon: true,
                        },
                        { text: translate('Unlimited usage (basic tools)'), icon: true },
                        {
                            text: translate('<span class="text-primary font-weight-bold">AI Creator Studio</span>'),
                            icon: true,
                        },
                        { text: translate('Advanced options'), icon: true },
                    ],
                    isMostPopular: true,
                    showLearnMore: false,
                    styles: 'height:179px;',
                },
                {
                    learnMoreTexts: [
                        translate('Enjoy unlimited access to basic tools such as Photo Editor, Compress, and more.'),
                        translate(
                            'Gain <strong>1600 Credits</strong> to utilize premium tools like AI Upscale, Colorize image, and others.'
                        ),
                        translate('All the features within our tools are unlocked.'),
                        ...this.learnMoreTexts,
                    ],
                    planBillingItemUse: translate('Frequent use'),
                    priceStringMonthly: this.getMonthlyPrice('ultimate'),
                    planBillingItemCredit: '1600',
                    itemValue: 'ultimate',
                    name: 'ultimate',
                    transKey: 'Ultimate',
                    infoTexts: [
                        {
                            text: translate(
                                '<strong>1600 Credits</strong> for <span class="text-primary font-weight-bold">premium tasks</span>'
                            ),
                            icon: true,
                        },
                        { text: translate('Unlimited access to all basic tools'), icon: true },
                        {
                            text: translate('<span class="text-primary font-weight-bold">AI Creator Studio</span>'),
                            icon: true,
                        },
                        { text: translate('Advanced options'), icon: true },
                        { text: translate('All features unlocked'), icon: true },
                    ],
                    styles: 'height:203px',
                    showLearnMore: false,
                },
            ];

            if (this.store.userPaymentModal.onlyProAndUltimate === false) {
                this.plans.unshift({
                    learnMoreTexts: [
                        translate('Enjoy unlimited access to basic tools such as Photo Editor, Compress, and more.'),
                        translate(
                            'Gain <strong>60 Credits</strong> to utilize premium tools like AI Upscale, Colorize image, and others.'
                        ),
                        ...this.learnMoreTexts,
                    ],
                    planBillingItemUse: translate('Occasional use'),
                    priceStringMonthly: this.getMonthlyPrice('starter'),
                    planBillingItemCredit: '60',
                    itemValue: 'starter',
                    name: 'starter',
                    transKey: 'Starter',
                    infoTexts: [
                        {
                            text: translate(
                                '<strong>60 Credits</strong> for <span class="text-primary font-weight-bold">premium tasks</span>'
                            ),
                            icon: true,
                        },
                        { text: translate('Unlimited usage (basic tools)'), icon: true },
                    ],
                    styles: 'height:131px',
                    showLearnMore: false,
                });
            }
        },
        toggleLearnMore(name) {
            // plan.showLearnMore = !plan.showLearnMore;
            this.plans.map((x) => {
                if (x.name === name) {
                    x.showLearnMore = !x.showLearnMore;
                } else {
                    x.showLearnMore = false;
                }
            });
            eventBus.emit(TOGGLE_LEARN_MORE, name);
        },
        openContactSupport() {
            globalLogger.log('user modal - legacy user - contact form');

            this.$router.push({
                name: userModalRoute.CONTACT_US_FORM,
                params: {
                    defaultQuestionType: 'sales',
                },
            });
        }
    },
    data() {
        return {
            selectedProduct: 'pro',
            plans: [],
            showLearnMore: false,
        };
    },
};
</script>
<style scoped lang="scss">
.learn-more-link {
    padding-left: 13%;
    width: fit-content;
}
.title-text {
    display: flex;
    gap: 5px;
    align-items: center;
}
.most-popular-badge-mobile {
    display: none;
}
.fa-check {
    color: #0b7335;
}
.most-popular-badge {
    position: absolute;
    width: 44px;
    height: 183px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    margin-left: -29px;
    // margin-top: -1px;
    border: 1px solid #1266f1;
    background-color: #1266f1;
    padding: 5px 15px 5px 15px;
    span {
        transform: rotate(270deg);
        clear: both;
        display: inline-block;
        white-space: nowrap;
        align-self: center;
    }
}
.most-popular-br-8 {
    border: 2px solid #1266f1 !important;
    border-radius: 0px 8px 8px 0px;
}
@media (max-width: 560px) {
    .most-popular-badge {
        display: none;
    }
    .most-popular-br-8 {
        border-radius: 8px;
    }
    .most-popular-badge-mobile {
        display: block;
        background-color: #1266f1;
        border-radius: 8px;
        padding: 4px 10px 4px 10px;
        font-size: 10px;
        font-weight: 600;
        color: white;
    }
}
</style>
